import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { userMe, getUserToken, setUserToken, userLogin, userRegister } from '../lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    if (!getUserToken()) { setLoading(false); return; }
    userMe()
      .then((u) => alive && setUser(u))
      .catch(() => alive && setUser(null))
      .finally(() => alive && setLoading(false));
    return () => { alive = false; };
  }, []);

  const login = useCallback(async (mobile, password) => {
    await userLogin({ mobile, password });
    const u = await userMe();
    setUser(u);
    return u;
  }, []);

  const register = useCallback(async (name, mobile, password) => {
    await userRegister({ name, mobile, password });
    const u = await userMe();
    setUser(u);
    return u;
  }, []);

  const logout = useCallback(() => {
    setUserToken(null);
    setUser(null);
  }, []);

  const refresh = useCallback(async () => {
    try { const u = await userMe(); setUser(u); } catch (e) { /* noop */ }
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
